import PropTypes from 'prop-types';

import {
  ALIMENTACAO,
  FROTA,
  MULTIBENEFICIOS_LIMITE,
  MULTIBENEFICIOS_SALDO,
  REFEICAO,
  CULTURA,
  NATAL,
  REFEICAO_PAT,
  ALIMENTACAO_PAT
} from '../../constants/products';

const CardAlimentacaoImage = '/cards/alimentacao-card-v2.png';
const CardRefeicaoImage = '/cards/refeicao-card-v2.png';
const CardMultiImage = '/cards/mult-card-v3.png';
const CardFrotaImage = '/cards/frota-card-v2.png';
const CardCulturaImage = '/cards/cultura-card-v2.png';
const CardNatalImage = '/cards/natal-card-v2.png';
import './CardImages.style.scss';

export const CardImages = (props) => {
  const setImage = () => {
    switch (props.card.id) {
      case REFEICAO:
      case REFEICAO_PAT:
        return CardRefeicaoImage;

      case ALIMENTACAO:
      case ALIMENTACAO_PAT:
        return CardAlimentacaoImage;

      case MULTIBENEFICIOS_LIMITE:
      case MULTIBENEFICIOS_SALDO:
        return CardMultiImage;

      case FROTA:
        return CardFrotaImage;

      case CULTURA:
        return CardCulturaImage;

      case NATAL:
        return CardNatalImage;

      default:
        return '';
    }
  };

  const getCardName = () => {
    if (
      (props.card.id === (MULTIBENEFICIOS_LIMITE || MULTIBENEFICIOS_SALDO) &&
        props.card.name.includes('Multibenefícios Limite')) ||
      props.card.name.includes('Multibenefícios Saldo')
    ) {
      return 'Multibenefícios Saldo / Limite';
    }
    if (props.card.id === REFEICAO_PAT || props.card.id === REFEICAO) {
      return 'Refeição PAT/Auxílio';
    }
    if (props.card.id === ALIMENTACAO_PAT || props.card.id === ALIMENTACAO) {
      return 'Alimentação PAT/Auxílio';
    }
    return props.card.name.replace('Alelo', '');
  };

  return (
    <div className="card-info-show" data-testid="show-card-image-from-psr">
      <img
        width={36}
        src={setImage()}
        alt={`Imagem do cartão ${props.card.name}`}
      />
      <p>{getCardName()}</p>
    </div>
  );
};

CardImages.propTypes = {
  card: PropTypes.object
};
